<ion-card>
  <ion-card-header>
    <ion-card-title>Lista Richieste di Arruolamento Pazienti</ion-card-title>
  </ion-card-header>
  <ion-card-content>
    <app-hint-msg size="small">
      <span>Cliccando sul titolo di una colonna è possibile ordinare i dati secondo la colonna
        scelta</span>
    </app-hint-msg>

    <app-hint-msg size="small">
      <span>
        Avvicinandosi con il mouse ai bordi dell'intestazione di una colonna è possibile aumentare
        o ridurre le dimensioni della colonna
      </span>
    </app-hint-msg>
    <ag-grid-angular c3DarkTable [modules]="agModules" [rowData]="rowData$ | async" [columnDefs]="columnDefs"
                     [gridOptions]="agGridOptions" (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </ion-card-content>
</ion-card>

<ng-template #mmgNotesCellTmpl let-cell>
  <ion-buttons>
    <ion-button c3Tooltip="Visualizza note dello specialista" fill="clear" size="small"
                (click)="viewsNotes($event, cell?.data)">
      <ion-icon slot="icon-only" color="primary" [src]="'information-outline' | getIcon"></ion-icon>
    </ion-button>
  </ion-buttons>
</ng-template>

<ng-template #actionsCellTmpl let-cell>
  <ion-buttons slot="start">
    <ion-button color="primary" c3Tooltip="Prendi in carico paziente" (click)="onOpenAddPatient(cell?.data)">
      <ion-icon size="large" name='checkmark-circle-outline' color="success"></ion-icon>
    </ion-button>
    <ion-button color="danger" c3Tooltip="Rifiuta presa in carico paziente"
                (click)="enrolmentActions($event, cell?.data, false)">
      <ion-icon size="large" name='close-circle-outline' color="danger"></ion-icon></ion-button>
  </ion-buttons>
</ng-template>